export const consultantSettingsArticle = {
  title: 'AI Business Consultant: Settings',
  slug: 'consultant-settings',
  content: `AI Business Consultant: Settings

Use Settings to tune AI features and digests.

1) Voice & audio
- Enable Text-to-Speech to read responses aloud.
- Enable Auto-send Voice Messages if you dictate responses.

2) Business context
- Toggle “Use Business Context” to include business data in replies.

3) Digests (if enabled)
- Configure daily digests and delivery channels.
- Set targets for revenue and meetings to track progress.
`,
};
